function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.79 0A5.74 5.74 0 000 5.64c0 3 5.34 10 5.57 10.25a.26.26 0 00.21.11.24.24 0 00.22-.11c.23-.29 5.57-7.22 5.57-10.25A5.73 5.73 0 005.79 0zm0 8.59a3 3 0 113-3 3 3 0 01-3 3z",
  fill: "#61c250"
});

function SvgPin(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 11.57 16"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/pin.d101c98e.svg";
export { SvgPin as ReactComponent };